export const INVOICE_KEYS = [
  'items',
  'original_items',
  'items',
  'worklogs',
  'original_worklogs',
  'allocations',
];
